import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Card, Heading, Text } from '@modusign/design-system';

interface InPersonPageErrorCardProps {
  onRetryClick?: () => void;
}

export default function InPersonPageErrorCard({ onRetryClick }: InPersonPageErrorCardProps) {
  return (
    <Card
      alignItems="center"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      p={[7, 7, 9]}
    >
      <Box color="iconNeutralBase" fontSize="32px" mb={6}>
        <FontAwesomeIcon icon={faExclamationCircle as IconProp} />
      </Box>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        mb={8}
        width="100%"
      >
        <Heading fontSize="md" fontWeight="medium" mb={3}>
          문서 정보를 불러오지 못했습니다.
        </Heading>
        <Text>문서 정보를 불러오지 못했습니다.</Text>
        <Text>일시적인 현상이거나 네트워크 문제일 수 있으니, 페이지를 새로고침해 주세요.</Text>
      </Box>
      {onRetryClick && (
        <Button mb={4} onClick={onRetryClick}>
          새로고침
        </Button>
      )}
    </Card>
  );
}
